export default __webpack_public_path__ + "static/media/demo-doodle-2.024bb312.png";